import React from 'react';
import Grade1to9a from 'views/HealthAndWellnesClub';

const Grade1to9Guideline = () => {
  return <Grade1to9a />;
};

export default Grade1to9Guideline;